import React from 'react';

import Modal from './Modal';
import NoteCreationPanel from './NoteCreationPanel';

/*
Call this with
    <NewNoteModal
        show={the condition under which it should show}
        noteId={whatever (0 to create a new note)}
        noteCreationFunc={(text) => a function(text) to create the Note in DB, etc}
        noteDeletionFunc={() => function() to delete the Note in DB and Redux} (optional)
        closeModalFunc={a function for closing the dialog}
    />
*/

export default class NoteModal extends React.Component {
  saveNoteAndCloseModal = (text) => {
    this.props.noteCreationFunc(text);
    this.props.closeModalFunc();
  };

  deleteNoteAndCloseModal = () => {
    this.props.noteDeletionFunc();
    this.props.closeModalFunc();
  };

  render() {
    const { show, noteId, closeModalFunc } = this.props;

    const verb = noteId ? 'Edit or Delete' : 'Create';
    const title = verb + ' Note';
    return (
      <Modal open={show} title={title} hideButtons={true} onCancel={() => closeModalFunc()}>
        <div style={{ minWidth: '400px' }}>
          <NoteCreationPanel
            noteId={noteId}
            noteCreationFunc={(text) => this.saveNoteAndCloseModal(text)}
            noteDeletionFunc={() => this.deleteNoteAndCloseModal()}
          />
        </div>
      </Modal>
    );
  }
}
